const ActionTypes = require('../constants/ActionTypes');

const CrisisActions = {

    updateIntensity(intensity) {
        return {
            type: ActionTypes.CRISIS_UPDATE_INTENSITY,
            payload: {
                intensity,
            },
        };
    },

    updateCrisis(crisis) {
        return {
            type: ActionTypes.CRISIS_UPDATE_CRISIS,
            payload: {
                crisis,
            },
        };
    },

    updateCrisisSound(crisisSound) {
        return {
            type: ActionTypes.CRISIS_UPDATE_SOUND,
            payload: {
                crisisSound,
            },
        };
    },

    updateInstability() {
        return {
            type: ActionTypes.CRISIS_UPDATE_INSTABILITY,
        };
    },

    updateInstabilityDelta(instabilityDelta) {
        return {
            type: ActionTypes.CRISIS_UPDATE_INSTABILITY_DELTA,
            payload: {
                instabilityDelta,
            },
        };
    },

};

module.exports = CrisisActions;



// WEBPACK FOOTER //
// ./js/actions/CrisisActions.js